import { render, staticRenderFns } from "./BasePrint.vue?vue&type=template&id=62f2f006&scoped=true&"
import script from "./BasePrint.vue?vue&type=script&lang=js&"
export * from "./BasePrint.vue?vue&type=script&lang=js&"
import style0 from "./BasePrint.vue?vue&type=style&index=0&id=62f2f006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f2f006",
  null
  
)

export default component.exports